import { render, staticRenderFns } from "./training.vue?vue&type=template&id=4c87a79d&scoped=true&lang=pug"
import script from "./training.vue?vue&type=script&lang=js"
export * from "./training.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87a79d",
  null
  
)

/* custom blocks */
import block0 from "./training.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports